
const m = window.require("@ember/error");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
